import type { ICategory } from "app/common/services/categoryService.types";
import type { IRawData, IFilters } from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";

import {
    INITIAL_RAW_DATA_STATE,
    INITIAL_FILTERS,
} from "app/pages/industry-analysis/market-builder/tabs/industry/table/constants";

import type { ESelectDomainOptions, IDomains } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";

export interface IIndustryState {
    selectedIndustry: ICategory;
    tableRawData: IRawData;
    filters: IFilters;
}

export const INITIAL_INDUSTRY_TAB_STATE: IIndustryState = {
    selectedIndustry: undefined,
    tableRawData: INITIAL_RAW_DATA_STATE,
    filters: INITIAL_FILTERS,
};

export type OnAddMultipleWebsites = (
    domains: IDomains,
    shouldSyncFavicons?: boolean,
    section?: ESelectDomainOptions,
) => void;
